import Login from '@/views/auth/views/Login.vue';
import Register from '@/views/auth/views/Register.vue';
import ForgotPassword from '@/views/auth/views/ForgotPassword.vue';
import ResetPassword from '@/views/auth/views/ResetPassword.vue';
import MfaSendCode from '@/views/auth/views/MfaSendCode.vue';
import MfaVerifyCode from '@/views/auth/views/MfaVerifyCode.vue';
//import AccessDenied from '@/views/auth/views/AccessDenied.vue';

export default [
  {
    path: '/',
    component: Login   
  },
  {
    path: '/register/',
    component: Register 
    //component: () => import('@/views/auth/views/Register.vue')
  },
  {
    path: '/forgot-password/',
    component: ForgotPassword
    //component: () => import('@/views/auth/views/ForgotPassword.vue')
  },
  {
    path: '/reset-password/',
    component: ResetPassword
    //component: () => import('@/views/auth/views/ForgotPassword.vue')
  },
  {
    path: '/mfa-send-code/',
    component: MfaSendCode
    //component: () => import('@/views/auth/views/MfaSendCode.vue')
  },
  {
    path: '/mfa-verify-code/',
    component: MfaVerifyCode
    //component: () => import('@/views/auth/views/MfaVerifyCode.vue')
  }
  /*
  ,
  {
    path: '/access-denied/',
    component: AccessDenied
    //component: () => import('@/views/auth/views/AccessDenied.vue')
  }*/
];